import { render } from "./AirportForm.vue?vue&type=template&id=f79dc876"
import script from "./AirportForm.vue?vue&type=script&lang=js"
export * from "./AirportForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__